import { ICondition } from "../State";
import SpinModel from "../../model/SpinModel";

export class HasCascadeCondition implements ICondition {
    public check(): boolean {
        let hasCascades = SpinModel.cascades && SpinModel.cascades.length > 0;

        return (
            hasCascades &&
            (SpinModel.cascadeIndex >= 0 &&
                SpinModel.cascadeIndex < SpinModel.cascades.length)
        );
    }
}
